export const ETH_EUR_RATE = 108.15